// Pagina publica /termos — Termos e Condicoes de Atendimento. Sem login.
// Onda Google camada 1 — explica o modelo: consulta no catalogo -> atendimento ->
// compra e retirada presencial com NF. Sinal de confianca pro Merchant.
import { PaginaInstitucional, Secao } from './PaginaInstitucional';
import { LinksWhatsapp } from './LinksWhatsapp';

const ATUALIZADO_EM = '27 de junho de 2026';

export function CatalogoPublicoTermos() {
  return (
    <PaginaInstitucional
      subtitulo="Termos de Atendimento"
      titulo="Termos e Condicoes de Atendimento"
      atualizadoEm={ATUALIZADO_EM}
    >
      <p className="mt-4 text-sm leading-relaxed text-gray-700">
        Estes termos explicam como funciona o atendimento e a compra de produtos da
        Fio de Cobre a partir do catalogo digital disponivel em
        fiodecobre.com.br/catalogo.
      </p>

      <Secao titulo="1. Quem somos">
        <p>
          <strong>FIO DE COBRE LTDA</strong>, CNPJ 49.762.154/0001-00, com loja na Av.
          Rio da Prata, 920, Setor Montes Belos, Sao Luis de Montes Belos / GO, CEP
          76052-201. Trabalhamos com materiais eletricos, acessorios de instalacao de
          ar condicionado e itens para piscina.
        </p>
      </Secao>

      <Secao titulo="2. O catalogo e uma vitrine de consulta">
        <p>
          O catalogo digital serve para voce consultar produtos, precos e
          disponibilidade. <strong>Ele nao e uma loja de compra online</strong>: nao ha
          carrinho, pagamento pelo site nem cadastro. Os precos e as imagens sao
          informativos e podem ser alterados sem aviso previo; em caso de divergencia,
          vale a informacao confirmada pela nossa equipe no atendimento.
        </p>
      </Secao>

      <Secao titulo="3. Como comprar">
        <ul className="list-disc pl-5 space-y-1">
          <li>Voce consulta o produto no catalogo;</li>
          <li>
            Fala com a gente pelo WhatsApp{' '}
            <LinksWhatsapp className="font-medium" style={{ color: '#b45309' }} />{' '}
            ou vem direto a loja;
          </li>
          <li>Confirmamos preco, disponibilidade e a forma de pagamento;</li>
          <li>
            A compra e <strong>finalizada e retirada presencialmente na loja</strong>,
            sempre com emissao de nota fiscal.
          </li>
        </ul>
      </Secao>

      <Secao titulo="4. Pagamento">
        <p>
          O pagamento e feito na loja, no momento da compra. Aceitamos dinheiro, Pix e
          cartoes de credito e debito. As condicoes (parcelamento, descontos a vista ou
          no Pix) sao informadas pela equipe no atendimento.
        </p>
      </Secao>

      <Secao titulo="5. Entrega e retirada">
        <p>
          As compras sao <strong>retiradas na propria loja</strong>. Nao realizamos
          envio por transportadora ou correios pelo catalogo. O horario de
          funcionamento esta na pagina{' '}
          <a href="/a-loja" className="font-medium" style={{ color: '#b45309' }}>
            A Loja
          </a>
          .
        </p>
      </Secao>

      <Secao titulo="6. Trocas e devolucoes">
        <p>
          As regras de troca e devolucao estao descritas na pagina{' '}
          <a
            href="/trocas-e-devolucoes"
            className="font-medium"
            style={{ color: '#b45309' }}
          >
            Trocas e Devolucoes
          </a>
          .
        </p>
      </Secao>

      <Secao titulo="7. Privacidade">
        <p>
          O tratamento dos seus dados segue a nossa{' '}
          <a href="/privacidade" className="font-medium" style={{ color: '#b45309' }}>
            Politica de Privacidade
          </a>
          , conforme a LGPD.
        </p>
      </Secao>

      <Secao titulo="8. Contato">
        <p>
          Duvidas sobre estes termos:{' '}
          <a
            href="mailto:atendimento@fiodecobre.com.br"
            className="font-medium"
            style={{ color: '#b45309' }}
          >
            atendimento@fiodecobre.com.br
          </a>{' '}
          ou WhatsApp <LinksWhatsapp className="font-medium" style={{ color: '#b45309' }} />.
        </p>
      </Secao>
    </PaginaInstitucional>
  );
}
